import Helper from './Helper';

class ImageCombination {

  constructor(config = {}) {
    const {
      imageCombinationContainer
    } = config;

    this.imageContainer = document.querySelectorAll(imageCombinationContainer);
    this.imageContainerArray = Array.prototype.slice.call(this.imageContainer);
    if (this.imageContainer) {
      this.imageContainerArray.forEach(container => {
        this.addClassOnEvenItems(container);
      });
    }
  }

  addClassOnEvenItems(imageContainer) {
    const items = imageContainer.querySelectorAll('.ns-img-combination__item');

    for ( var i = 0; i < items.length; i++ ) {
      if ( i % 2 === 1 ) {
        Helper.addClass(items[i], "ns-img-combination__item--align-right");
      }
    }
  }

}

export default ImageCombination;
